import React, { useState } from "react";
import CameraIcon from "./assets/icons/camera-icon-white.png";
import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import Style from "./styledbutton"

export default function Navbar() {
    const [isShown, setIsShown] = useState(false);

    return (
        <nav>
            <Style/>
            {/* <div className="nav--portfolio-link-container">
                <AwesomeButton className="nav--portfolio-link" href="https://victorkangphotography.com/" target="_blank" type="youtube">
                    TO PORTFOLIO
                </AwesomeButton>
            </div> */}
            <div className="nav--title-container">
                <h1 className="nav--title-v">
                    V
                </h1>
                <img src={CameraIcon} className="camera-icon"/>
                <h1 className="nav--title-k">
                    K
                </h1>
                <h1 className="nav--title-PJ">
                    Photography Journal
                </h1>
                <AwesomeButton  className="nav--portfolio-link" href="https://victorkangphotography.com/" target="_blank" onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)} >
                    TO GALLERY
                </AwesomeButton>
                {isShown && (
                    <div>
                        test
                    </div>
                )}
            </div>
            <div className="nav--portfolio-link-container">
                
            </div>
        </nav>
    )
}

